import {workspaceSortQuery} from '../platform/tableSort.js';
/** Same endpoint for startup prefetch and the mounted meetings page. */
export function meetingListEndpoint(tab, search = '', sort) {
  const params = new URLSearchParams(search);
  params.delete('tab');params.delete('sync');
  params.delete('sort');params.delete('order');
  if(sort)for(const [key,value] of Object.entries(workspaceSortQuery(tab==='recordings'?'my-recordings':'meetings',sort)))params.set(key,value);
  if(tab==='calendar')return '/api/meetings?page_size=200&include_invited=1';
  if(['recordings','summaries','reports'].includes(tab)){if(tab==='recordings')params.set('view','list');return `/api/meeting-recordings${params.size?'?'+params.toString():''}`;}
  return `/api/meetings${params.size?'?'+params.toString():''}`;
}
export function startupMeetingsEndpoint(pathname, search, desktop, sort) {
  if(!/^\/conferencing\/meetings\/?$/.test(pathname))return '';
  const params=new URLSearchParams(search);
  const tab=params.get('tab')||(desktop&&!['query','type','page'].some(k=>params.has(k))?'calendar':'meetings');
  return ['calendar','meetings','list'].includes(tab)?meetingListEndpoint(tab,search,sort):'';
}
